import { lazy } from 'react';
import Loadable from '../layouts/loader/Loadable';
import RequireAuth from '../components/RequireAuth';
import RequireRole from '../components/RequireRole';
import RequestAttendance from '../pages/request/RequestAttendance';
import RequestTimeOfff from '../pages/request/RequestTimeOfff';
import UserRoles from '../pages/settings/UserRoles';
import Attendance from '../pages/attendance/Attendance';
import PersonalDataForm from '../pages/Employees/PersonalDataForm/PersonalDataForm';
/****Layouts*****/

const FullLayout = Loadable(lazy(() => import('../layouts/FullLayout')));
const BlankLayout = Loadable(lazy(() => import('../layouts/BlankLayout')));
/***** Pages ****/

const Dashboard = Loadable(lazy(() => import('../views/dashboards/Dashboard')));

// Employees
const Employees = Loadable(lazy(() => import('../pages/Employees/Employees')));
// const EmployeesTable = Loadable(lazy(() => import('../pages/Employees/EmployeesTable')));
const EmployeesPersonal = Loadable(lazy(() => import('../pages/Employees/personal/Personal')));
const Employment = Loadable(lazy(() => import('../pages/Employees/employment/Employment')));
// End Of Employee

const UnauthorizedPage = Loadable(lazy(() => import('../pages/Unauthorized')));

/***** Auth Pages ****/
const Error = Loadable(lazy(() => import('../views/auth/Error')));
const RegisterFormik = Loadable(lazy(() => import('../views/auth/RegisterFormik')));
const LoginFormik = Loadable(lazy(() => import('../views/auth/LoginFormik')));
const Maintanance = Loadable(lazy(() => import('../views/auth/Maintanance')));
const LockScreen = Loadable(lazy(() => import('../views/auth/LockScreen')));
const RecoverPassword = Loadable(lazy(() => import('../views/auth/RecoverPassword')));

/***** MyInfo Pages ****/
const MyInfoPage = Loadable(lazy(() => import('../pages/myInfo/MyInfo')));
const PersonalSection = Loadable(lazy(() => import('../pages/myInfo/Personal')));
const EmploymentSection = Loadable(lazy(() => import('../pages/myInfo/Employment')));
const EducationSection = Loadable(lazy(() => import('../pages/myInfo/Education')));
const AttendanceSection = Loadable(lazy(() => import('../pages/myInfo/AttendanceSection')));
const TimeOffSection = Loadable(lazy(() => import('../pages/myInfo/TimeOffSection')));
const OvertimeSection = Loadable(lazy(() => import('../pages/myInfo/OvertimeSection')));
const PayrollSection = Loadable(lazy(() => import('../pages/myInfo/PayrollSection')));
const PaySlipSection = Loadable(lazy(() => import('../pages/myInfo/PaySlipSection')));
const PayslipDetail = Loadable(lazy(() => import('../pages/myInfo/PayslipDetail')));
const ReimbursementSection = Loadable(lazy(() => import('../pages/myInfo/ReimbursementSection')));

/***** Attendance Pages ****/
const AttendancePage = Loadable(lazy(() => import('../pages/attendance/Attendance')));

/***** Payroll Pages ****/
const MasterDirut = Loadable(lazy(() => import('../pages/payroll/MasterDirut')));
const Grade = Loadable(lazy(() => import('../pages/payroll/Grade')));
const DasarSatuanGaji = Loadable(lazy(() => import('../pages/payroll/DasarSatuanGaji')));
const Tunjangan = Loadable(lazy(() => import('../pages/payroll/Tunjangan')));
const Deduction = Loadable(lazy(() => import('../pages/payroll/Deduction')));
const TabelGajiKaryawan = Loadable(
  lazy(() => import('../pages/payroll/penggajian/TabelGajiKaryawan')),
);
// const Keuangan = Loadable(lazy(() => import('../pages/payroll/Keuangan')));
// const PenggajianFinance = Loadable(
//   lazy(() => import('../pages/payroll/penggajianFinance/PenggajianFinance')),
// );

/***** Payroll Page **** */
const PayrollPage = Loadable(lazy(() => import('../pages/payroll/PayrollPage')));
/***** End Payroll Page **** */

/***** Candidate Pages ****/
const CandidatePage = Loadable(lazy(() => import('../pages/candidate/Candidate')));

/***** Candidate Pages ****/
const SettingsPage = Loadable(lazy(() => import('../pages/settings/Settings')));

/***** Employee Setting Pages ****/
// const EmployeeSettingPage = Loadable(
//   lazy(() => import('../pages/EmployeeSetting/EmployeeSetting')),
// );

/***** Approval Pages ******/
const ApprovalPage = Loadable(lazy(() => import('../pages/approval/Approval')));

/***** Setting Pages ******/
const SettingApprovalPage = Loadable(lazy(() => import('../pages/settings/approval/Approval')));
const SettingStructurePage = Loadable(lazy(() => import('../pages/settings/structure/Structure')));

/***** Master Pages ****/
const MasterDivisionPage = Loadable(lazy(() => import('../pages/master/division/MasterDivision')));
const MasterPositionPage = Loadable(lazy(() => import('../pages/master/position/MasterPosition')));
/***** End Master Pages ****/

/***** Report Pages ****/
const PresenceReport = Loadable(lazy(() => import('../pages/report/presence/PresenceReport')));
const TimeOffReport = Loadable(lazy(() => import('../pages/report/timeOff/TimeOffReport')));
const PayrollReport = Loadable(lazy(() => import('../pages/report/payroll/PayrollReport')));
/***** End Report Pages ****/

// ***** Admin Pages ****/
const AdminPanelPage = Loadable(lazy(() => import('../pages/admin/adminPanel/AdminPanel')));
const AdminRequestAttendance = Loadable(
  lazy(() => import('../pages/admin/request/AttendanceRequest')),
);
const AdminTimeOffRequest = Loadable(lazy(() => import('../pages/admin/request/TimeOffRequest')));
const RecapPage = Loadable(lazy(() => import('../pages/admin/recap/RecapPage')));
/***** End Admin Pages ****/

/***** User Guide ****/
const UserGuidePage = Loadable(lazy(() => import('../pages/userGuide/UserGuide')));
/***** End User Guide ****/

// Review
const Review = Loadable(lazy(() => import('../pages/review/Review')));
// End Review

// OrgChart
const OrgChartPage = Loadable(lazy(() => import('../pages/OrgChart/OrgChartPage')));
// End OrgChart

// Notification
const NotificationPage = Loadable(lazy(() => import('../pages/notification/Notification')));
// Notification

/*****Routes******/

const ThemeRoutes = [
  {
    path: '/',
    element: <RequireAuth allowedRoles={['1024']} />,
    children: [
      {
        path: '/',
        element: <FullLayout />,
        children: [
          { path: '/', name: 'Home', exact: true, element: <Dashboard /> },
          {
            path: '/my-info',
            element: <MyInfoPage />,
            children: [
              { path: 'personal', element: <PersonalSection /> },
              { path: 'employment', element: <EmploymentSection /> },
              { path: 'education', element: <EducationSection /> },
              { path: 'attendance', element: <AttendanceSection /> },
              { path: 'time-off', element: <TimeOffSection /> },
              { path: 'overtime', element: <OvertimeSection /> },
              { path: 'overtime', element: <OvertimeSection /> },
              { path: 'overtime', element: <OvertimeSection /> },
              { path: 'payroll', element: <PayrollSection /> },
              { path: 'payslip', element: <PaySlipSection /> },
              { path: 'payslip/:id/detail', element: <PayslipDetail /> },
              { path: 'reimbursement', element: <ReimbursementSection /> },

              {
                path: 'add-personal-data',
                element: <PersonalDataForm />, // tambahan data karyawan akses melalui data pengumuman
              },
            ],
          },
          {
            path: '/employees',
            name: 'Employees',
            element: <RequireRole allowedRoles={['2131', '1024']} />,
            children: [{ path: '', element: <Employees /> }],
          },
          {
            path: `/employees/personal/:employee_id`,
            name: 'EmployeesPersonal',
            exact: true,
            element: <RequireRole allowedRoles={['2131', '3402']} />,
            children: [{ path: '', element: <EmployeesPersonal /> }],
          },
          {
            path: `/employees/employment/:employee_id`,
            name: 'EmploymentData',
            exact: true,
            element: <RequireRole allowedRoles={['2131', '3402']} />,
            children: [{ path: '', element: <Employment /> }],
          },
          {
            path: `/attendance`,
            name: 'Attendance',
            exact: true,
            element: <AttendancePage />,
          },
          {
            path: `/request`,
            name: 'Request',
            exact: true,
            element: <RequireRole allowedRoles={['1024', '2131']} />,
            children: [
              { path: 'attendance', element: <RequestAttendance /> },
              { path: 'time-off', element: <RequestTimeOfff /> },
            ],
          },
          {
            path: `/candidates`,
            name: 'Candidates',
            exact: true,
            element: <RequireRole allowedRoles={['2131']} />,
            children: [{ path: '', element: <CandidatePage /> }],
          },
          {
            path: `/payroll`,
            name: 'Payroll',
            exact: true,
            element: <PayrollPage allowedRoles={['1201', '0129', '8513']} />,
          },
          {
            path: `/payroll`,
            name: 'Payroll',
            element: <RequireRole allowedRoles={['1201', '0129']} />,
            children: [
              { path: 'employee-salary/hr', element: <TabelGajiKaryawan /> },
              { path: 'master-dirut', element: <MasterDirut /> },
              { path: 'grade', element: <Grade /> },
              { path: 'dasar-satuan-gaji', element: <DasarSatuanGaji /> },
              { path: 'tunjangan', element: <Tunjangan /> },
              { path: 'deduction', element: <Deduction /> },
            ],
          },
          // {
          //   path: `/payroll`,
          //   name: 'Payroll',
          //   element: <PenggajianFinance allowedRoles={['8513']} />,
          // },
          // {
          //   path: `/master-data`,
          //   name: 'Master',
          //   element: <RequireRole allowedRoles={['2131']} />,
          //   children: [
          //     { path: 'division', element: <MasterDivisionPage /> },
          //     { path: 'position', element: <MasterPositionPage /> },
          //   ],
          // },
          {
            path: `/activities`,
            name: 'Activities',
            element: <RequireRole allowedRoles={['2131']} />,
            children: [
              { path: 'request-time-off', element: <AdminTimeOffRequest /> },
              { path: 'request-attendance', element: <AdminRequestAttendance /> },
            ],
          },
          {
            path: `/activities`,
            name: 'Aktifitas',
            element: <RequireRole allowedRoles={['2131']} />,
            children: [
              { path: 'request-time-off', element: <MasterDivisionPage /> },
              { path: 'request-attendance', element: <MasterPositionPage /> },
            ],
          },
          {
            path: `/report`,
            name: 'Report',
            element: <RequireRole allowedRoles={['2131']} />,
            children: [
              { path: 'presence', element: <PresenceReport /> },
              { path: 'time-off', element: <TimeOffReport /> },
              { path: 'payroll', element: <PayrollReport /> },
            ],
          },
          {
            path: `/settings`,
            name: 'Settings',
            element: <RequireRole allowedRoles={['2131']} />,
            children: [
              { path: '', element: <SettingsPage /> },
              // { path: 'assign-grade', element: <EmployeeSettingPage /> },
              { path: 'roles', element: <UserRoles /> },
              { path: 'approval', element: <SettingApprovalPage /> },
              { path: 'structure', element: <SettingStructurePage /> },
            ],
          },
          {
            path: `/approval`,
            name: 'Aproval',
            element: (
              <RequireRole
                allowedRoles={['2131', '2190', '4219', '3402', '6011', '4944', '7520']}
              />
            ),
            children: [{ path: '', element: <ApprovalPage /> }],
          },
          {
            path: '/review',
            name: 'Review',
            element: <RequireRole allowedRoles={['2131', '1024']} />,
            children: [{ path: '', element: <Review /> }],
          },
          {
            path: '/attendance-log',
            name: 'Kehadiran',
            element: <RequireRole allowedRoles={['1024']} />,
            children: [{ path: '', element: <Attendance /> }],
          },
          {
            path: '/presence-recap',
            name: 'Rekapitulasi',
            element: <RequireRole allowedRoles={['2131', '1024']} />,
            children: [{ path: '', element: <RecapPage /> }],
          },
          {
            path: `/admin-panel`,
            name: 'Admin Panel',
            element: <RequireRole allowedRoles={['2131', '0129']} />,
            children: [{ path: '', element: <AdminPanelPage /> }],
          },
          {
            path: '/org-chart',
            name: 'Org Chart',
            element: <RequireRole allowedRoles={['2131']} />,
            children: [{ path: '', element: <OrgChartPage /> }],
          },
          {
            path: 'all-notifications',
            name: 'Notifications',
            element: <NotificationPage />,
          },
          {
            path: '/unauthorized',
            name: 'Unauthorized',
            element: <UnauthorizedPage />,
          },
        ],
      },
    ],
  },
  {
    path: '/auth',
    element: <BlankLayout />,
    children: [
      { path: '404', element: <Error /> },
      { path: 'registerformik', element: <RegisterFormik /> },
      { path: 'login', element: <LoginFormik /> },
      { path: 'maintanance', element: <Maintanance /> },
      { path: 'lockscreen', element: <LockScreen /> },
      { path: 'recoverpwd', element: <RecoverPassword /> },
    ],
  },
  {
    path: '/user-guide',
    element: <UserGuidePage />,
  },
];

export default ThemeRoutes;
